import type { SalePage } from 'types/capi/salePage';

import usePageData from '~/hooks/usePageData';
import useStructuredData from '~/hooks/useStructuredData';
import ContentBlock from '~/modules/ContentBlock';
import ShopBrandDeals from '~/modules/ShopBrandDeals';
import seo from '~/utils/seo';

import BannerCarousel from '../../modules/BannerCarousel';
import ProductsList from '../../modules/ProductList';
import ProductsHighlight from '../../modules/ProductsHighlight';

export default function Sale() {
  const { _schemas, modules } = usePageData<SalePage>();

  useStructuredData(_schemas);

  let plRenderCount = 0;

  return (
    <>
      <h1 className="hidden">The Sole Supplier</h1>
      {modules.map((module, index) => {
        switch (module.type) {
          case 'SPLASH':
            return <BannerCarousel key={module.type} slides={module.items} />;
          case 'PRODUCTS_HIGHLIGHT':
            return (
              <ProductsHighlight
                key={`${module.type}-${index}`}
                module={module}
                moduleIndex={index}
                pageType="sale"
              />
            );
          case 'PRODUCT_LIST':
            return (
              <ProductsList
                key={`${module.type}-${index}`}
                module={module}
                pagePosition={`Sale Product List-${index}`}
                backgroundColour={
                  plRenderCount++ % 2 === 0 ? 'bg-white' : 'bg-grey-tile'
                }
                pageType="sale"
              />
            );
          case 'SHOP_BRAND_DEALS':
            return (
              <ShopBrandDeals module={module} key={`${module.type}-${index}`} />
            );
          case 'CONTENT_BLOCK':
            return (
              <ContentBlock module={module} key={`${module.type}-${index}`} />
            );
          case 'SEASONAL_BANNER':
            return <BannerCarousel key={module.type} slides={[module]} />;
          default:
            return null;
        }
      })}
    </>
  );
}

type LoaderData = {
  pageData: SalePage;
};

export { loader } from './loader.server';
export const meta = ({ data }: { data?: LoaderData }) => {
  return data
    ? seo.formatForMeta(data.pageData.canonical_url, data.pageData.seo)
    : [];
};
